import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  connectingTo: {
    defaultMessage: 'Connecting to {providerName}, please wait...',
    id: 'AddCredentialsPage.connectingTo',
  },
  connectingToAlternative: {
    defaultMessage: 'Connecting to {providerName}. This can take a few minutes. Please wait...',
    id: 'AddCredentialsPage.connectingToAlternative',
  },
  gettingAccountsInfo: {
    defaultMessage: 'Retrieving accounts...',
    id: 'AddCredentialsPage.gettingAccountsInfo',
  },
});
